<template>
  <div style="min-height: 92vh">
    <div v-show="!showCreator">
      <ModuleHeader>Orden de compra por presentaciones</ModuleHeader>
      <v-row>
        <v-col md="4" cols="12">
          <v-menu
            v-model="menuFechaInicial"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="input_date"
                label="Fecha Inicial"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="input_date"
              @input="menuFechaInicial = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="4" cols="12">
          <v-menu
            v-model="menuFechaInicial2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="input_date_final"
                label="Fecha Final"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="input_date_final"
              @input="menuFechaInicial2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="4" cols="12">
          <v-btn color="success" @click="getDocuments()">Buscar</v-btn>
        </v-col>
      </v-row>
      <uv-data-table
        :config="config"
        :data="Documentos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>

    <modal
      v-model="showModal"
      :showFooter="false"
      :fullscreen="true"
      title="Orden de compra"
    >
      <OrdenCompraFormV2
        :edit="editMode"
        @toggle="toggleModal"
        @successData="successData"
        :presentaciones="presentaciones"
        :key="formIndex"
        :dataEdit="editData"
      />
    </modal>

    <modal v-model="pdfModal" :showFooter="false" :title="'Vista de PDF'">
      <v-card class="pa-4">
        <v-card-text>
          <h3 class="text-center">¿Desea separar cada página por proveedor?</h3>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-row justify="center" align="center">
            <v-col md="5" class="text-center">
              <v-btn
                color="green"
                dark
                block
                @click="generatePdf(dataDocs, true)"
              >
                Sí
              </v-btn>
            </v-col>
            <v-col md="5" class="text-center">
              <v-btn
                color="red"
                dark
                block
                @click="generatePdf(dataDocs, false)"
              >
                No
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </modal>
  </div>
</template>

<style></style>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
// import OrdenesCompraForm from './OrdenCompraForm.vue';
import OrdenCompraFormV2 from "./OrdenCompraFormV2.vue";
import AcuseOrdenCompra from "../../../clases/PdfMakers/AcuseOrdenCompra";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import Compra from "../../../clases/Inventarios/Compras.js";

export default {
  name: "OrdenesCompraCRUD",
  components: {
    modal,
    uvDataTable,
    // OrdenesCompraForm,
    OrdenCompraFormV2,
  },
  props: [],
  data() {
    return {
      menuFechaInicial: false,
      menuFechaInicial2: false,
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      Proveedores: [],
      presentaciones: [],
      pdfModal: false,
      dataDocs: null,

      origenes: [],
      self: this,
      showModal: false,
      formKey: 0,
      Documentos: [],
      formIndex: 0,
      editMode: false,
      showCreator: false,
      editData: [],

      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: true,
        rawText: "Orden de compra",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Nueva orden de compra",
            icon: "lni lni-clipboard",
            buttonId: "addDocumentRecepcion",
          },
          {
            text: "Editar orden de compra",
            icon: "lni lni-pencil-alt",
            buttonId: "editDocumentRecepcion",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentRecepcion",
            require: true,
          },
        ],
        fields: [
          {
            text: "Documento orden de compras",
            value: "Nombre",
          },
          {
            text: "Fecha Creación",
            value: "Fecha",
          },
          {
            text: "Proveedores",
            value: "proveedoresArray",
            canBeFiltered: true,
          },
          {
            text: "Almacen",
            value: "origenNombre",
            canBeFiltered: true,
          },
          {
            canBeFiltered: true,
            text: "Estatus",
            value: "Status",
            format: (row) => {
              if (row["sts"] == "OC") {
                return '<b style="color:green;">Orden de Compra</b>';
              }
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "red",
                text: "PDF",
                buttonId: "acusePDF",
                value: "id",
              },
              {
                color: "green",
                text: "Enviar a compra",
                buttonId: "enviarCompra",
                value: "id",
                showBy: "availableToSend",
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    async getProveedores() {
      let proveedorArray = [];
      const database = await this.$store.getters.getFirebaseApp.database;
      const data = await database.queryBuilder("AMC/Provedores", []);
      if (data.exists()) {
        let arrayFactura = Object.entries(data.val());
        arrayFactura.forEach((element) => {
          proveedorArray.push({
            id: element[0],
            Nombre: element[1]["nom"],
          });
        });
        this.Proveedores = proveedorArray;
      }
    },
    async getPresentaciones() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("AMC_Presentaciones", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      if (data.empty) {
        this.presentaciones = [];
      } else {
        let doc = data.docs.map((doc) => {
          return { Id: doc.ref.id, ...doc.data() };
        });
        let presentaciones = [];
        doc.forEach((data) => {
          if (!data.Dlat) {
            presentaciones.push(data);
          }
        });
        this.presentaciones = presentaciones;
      }
    },

    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addDocumentRecepcion") {
        this.formIndex++;
        this.editMode = false;
        this.showModal = true;
      }
      if (buttonId == "editDocumentRecepcion") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.Documentos,
          "id",
          idSelected[0]
        );
        this.showModal = true;
      }

      if (buttonId == "deleteDocumentRecepcion") {
        this.deleteDoc(idSelected[0]);
      }

      if (buttonId == "acusePDF") {
        let data = this.$pgsHelper.getById(this.Documentos, "id", idSelected);
        if (data) {
          this.dataDocs = data;
          this.pdfModal = true;
        }
      }

      if (buttonId == "enviarCompra") {
        let data = this.$pgsHelper.getById(this.Documentos, "id", idSelected);
        let sendData = new Compra(data);
        sendData.sts = "P";

        this.$alert.alertConfirm({
          action: "enviar",
          obj: "la orden de compra a compras",
          route: "AMC-Compras-updateCompra",
          data: sendData,
          onSuccess: async () => {
            await this.getDocuments();
          },
        });
      }
    },
    groupData(data) {
      // Obtener el array de adquisiciones (adq) del objeto data
      let adquisiciones = data.adq ? data.adq : [];

      // Preparar agrupación por proveedor
      const agrupadosPorProveedor = adquisiciones.reduce((acc, producto) => {
        // Obtener la presentación específica del producto usando prs
        let presentacionProducto = this.$pgsHelper.getById(
          this.presentaciones,
          "Id",
          producto.prs
        );

        // Asignar a "Proveedor desconocido" si no se encuentra una presentación específica
        if (!presentacionProducto) {
          const proveedorDesconocido = "Proveedor desconocido";
          if (!acc[proveedorDesconocido]) {
            acc[proveedorDesconocido] = {
              proveedor: proveedorDesconocido,
              items: [],
            };
          }
          producto.proveedor = proveedorDesconocido;
          acc[proveedorDesconocido].items.push(producto);
        } else {
          // Obtener el proveedor asociado con la presentación
          let proveedor = this.Proveedores.find(
            (prv) => prv.id === presentacionProducto.pvd
          ) || { Nombre: "Proveedor desconocido" };

          producto.proveedor = proveedor.Nombre;

          // Agrupar por proveedor
          if (!acc[producto.proveedor]) {
            acc[producto.proveedor] = {
              proveedor: producto.proveedor,
              items: [],
            };
          }

          // Clonar el producto con la presentación específica
          let productoClonado = {
            ...producto,
            presentacion: presentacionProducto,
          };
          acc[producto.proveedor].items.push(productoClonado);
        }

        return acc;
      }, {});

      // Convertir agrupación en array de grupos
      let grupos = Object.values(agrupadosPorProveedor);
      let extraData = {
        Fecha: data.Fecha,
        dpt: data.dpt,
        origenNombre: data.origenNombre,
        dsc: data.dsc,
        nts: data.nts,
      };
      return { grupos, extraData };
    },

    async generatePdf(dataToPdf, pageBreak) {
      const { grupos, extraData } = this.groupData(dataToPdf);
      // console.log("dat", grupos, extraData);
      let mainData = {
        FI: extraData.Fecha || "Fecha no disponible", // Fecha inicial de la orden
        FG: new moment().format("DD/MM/YYYY"), // Fecha de generación del PDF
        HG: new moment().format("HH:mm:ss"), // Hora de generación del PDF
        TITLE: "ORDEN DE COMPRA",
        data: grupos, // Pasamos los grupos por proveedor
        dpt: extraData.dpt,
        origen: extraData.origenNombre,
        dsc: extraData.dsc,
        nts: extraData.nts,
        pageBreak: pageBreak, // Pasamos si queremos que se haga un salto de página por proveedor
      };

      // Generar el documento con los datos organizados
      let docData = AcuseOrdenCompra.getDocData(mainData);
      pdfmake.createPdf(docData).open();
      this.dataDocs = null;
      this.pdfModal = false;
    },

    async createDocument() {
      this.$swal({
        title: "¿Deseas crear un nuevo documento de recepción de mercancias?",
        text: "Al crear el documento podras agregar los productos necesarios para ingresar a inventario",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Crear Documento",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = {};
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-deleteCategoria", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento Creado",
              "El documento se creo correctamente",
              "success"
            );
            this.$router.push({
              path:
                "/productos-inventarios/documentoRecepcion/" +
                result.value.data.data.id,
            });
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    getDocuById(code) {
      let itemIndex = this.$_.findIndex(this.Documentos, { id: code });
      if (itemIndex >= 0) {
        return this.Documentos[itemIndex];
      }

      return false;
    },
    async successData() {
      await this.getDocuments();
      this.showModal = false;
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async deleteDoc(id) {
      let docu = this.getDocuById(id);
      // console.log(docu);
      if (docu.Aplicado != "OC") {
        this.$swal(
          "No puedes eliminar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }
      let datos = {
        Id: id,
        TipoMovimiento: "Entrada",
      };

      this.$swal({
        title: "¿Deseas el documento de entrada de mercancias?",
        text: "Al eliminarlo se perderan todos los datos",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AMC-Compras-cancelCompra", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento se elimino correctamente",
              "El documento se elimino correctamente",
              "success"
            );
            this.getDocuments();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    async getDocuments() {
      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );

      var data = await firestore.queryBuilder("AMC_Compras", [
        firestore.where("mmt", ">=", startDate),
        firestore.where("mmt", "<", end + "~"),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      document.forEach((data) => {
        if (data.sts === "OC") {
          let fecha = new moment(data.mmt, "YYYY-MM-DD_HH:mm:ss");
          let origenData = this.getOrigenById(data.amc);
          data.proveedoresArray = [];
          try {
            data.adq.forEach((ins) => {
              const producto = this.$pgsHelper.getById(
                this.global_prod,
                "id",
                ins.prd
              );

              const presentacionTotal = this.$pgsHelper.getById(
                this.presentaciones,
                "Id",
                ins.prs
              );

              const presentacion = presentacionTotal.pvd;
              ins.rdm = presentacionTotal.rdm;

              const proveedor =
                presentacion &&
                this.Proveedores.find((p) => p.id === presentacion)?.Nombre;

              if (proveedor) {
                ins.proveedor = proveedor;
                if (!data.proveedoresArray.includes(proveedor)) {
                  data.proveedoresArray.push(proveedor);
                }
              }
              if (producto) {
                ins.producto = {
                  nombre: producto.Nombre,
                  unidadMedida: producto.Extra?.AYB?.UM || "PZA",
                };
              }
            });
            data.proveedoresArray = data.proveedoresArray.join(", ");
          } catch (e) {
            console.log(e);
          }
          // data.proveedoresArray = [];
          // try {
          //   data.adq.forEach((ins) => {
          //     const presentacion = this.$pgsHelper.getById(
          //       this.presentaciones,
          //       "Id",
          //       ins.prs
          //     )?.pvd;
          //     const proveedor =
          //       presentacion &&
          //       this.Proveedores.find((p) => p.id === presentacion)?.Nombre;

          //     if (proveedor && !data.proveedoresArray.includes(proveedor)) {
          //       ins.proveedor = proveedor;
          //       data.proveedoresArray.push(proveedor);
          //     }
          //   });
          //   data.proveedoresArray = data.proveedoresArray.join(", ");
          // } catch (e) {
          //   console.log(e);
          // }
          let claims = this.$route.params.user.tokenResult.claims;
          let available = claims.Type != "Chef" ? true : false;
          this.Documentos.push({
            id: data.id,
            origenId: origenData.id,
            origenNombre: origenData.Nombre,
            Nombre: "Identificador: - " + data.id,
            Fecha: fecha.format("YYYY-MM-DD HH:mm"),
            //Departamento: data.Departamentos[0],
            Aplicado: data.sts,
            availableToSend: available,
            Status: data.sts == "F" ? "Completado" : "Pendiente",
            ...data,
          });
        }
      });
      this.Documentos = this.$_.orderBy(this.Documentos, "Fecha", "desc");
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    getOrigenById(code) {
      let itemIndex = this.$_.findIndex(this.origenes, { id: code });
      if (itemIndex >= 0) {
        return this.origenes[itemIndex];
      }

      return false;
    },
  },
  computed: {
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let productos = [];
      prod.forEach((element) => {
        if (element.Tipo == "AYB-Insumo" && !element.Dlat) {
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      let data = productos;
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");
      return sortReservations;
    },
  },
  watch: {},
  mounted() {},
  async created() {
    await this.getOrigenes();
    await this.getPresentaciones();
    await this.getProveedores();
    //await this.getDocuments();
  },
};
</script>
